import historico from '@/core/store/item-ata/realinhamento/historico'
import realinhar from '@/core/store/item-ata/realinhamento/realinhar'

export default {
	modules: {
		historico,
		realinhar,
	},
}
